import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PricelistDownloadRoutingModule } from './pricelist-download-routing.module';
import { PricelistDownloadComponent } from './pricelist-download.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { PricelistDownloadFilterComponent } from './pricelist-download-filter/pricelist-download-filter.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    PricelistDownloadRoutingModule
  ],
  declarations: [PricelistDownloadComponent, PricelistDownloadFilterComponent],
  entryComponents: [PricelistDownloadFilterComponent]

})
export class PricelistDownloadModule { }
